import { Component, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

@Component({
  selector: "app-table",
  templateUrl: "./table-widget.component.html",
  styleUrls: ["./table-widget.component.css"],
})
export class TableWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  
  history: number = 50;
  from: string;
  to: string;
  public c: any;

  public rangeLimiter: any;

  private colours: string[];

  public categories: string[] = [];

  widgetBeforeInit() {
    this.c = <any>this.config;
    if (this.c && this.c.dynamicTimeSeriesList){
      for (let c of this.c.dynamicTimeSeriesList){
        c.colour = "#d1dade";
      }
    }
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetAfterInit() {
    if (this.c && this.c.dynamicTimeSeriesList) {
      this.c.dynamicTimeSeriesList = this.c.dynamicTimeSeriesList.sort((a, b) => {
        const nameA = (a.displayName || '').toLowerCase();
        const nameB = (b.displayName || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    }
  }

  public isNaN(val){
    return typeof val != 'number';
  }

  refresh() {
    this.ngOnInit();
  }

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[] = ["timeSeriesHover", "timeSeriesUnhover", "timeSeriesSelect", "timeSeriesUnselect"];
  override timeSeriesEvent(type: string, uri: string): void {
    // find the series in the tableDetailList and set highlighted
    if (type === 'timeSeriesHover') {
      const series = this.c.dynamicTimeSeriesList.find(s => s.uri === uri);
      if (series) {
        series.highlighted = true;
      }
    } 
    else if (type === 'timeSeriesUnhover') {
      const series = this.c.dynamicTimeSeriesList.find(s => s.uri === uri);
      if (series) {
        series.highlighted = false;
      }
    }
    else if (type === 'timeSeriesSelect') {
      const series = this.c.dynamicTimeSeriesList.find(s => s.uri === uri);
      if (series) {
        series.selected = true;
      }
    }
    else if (type === 'timeSeriesUnselect') {
      const series = this.c.dynamicTimeSeriesList.find(s => s.uri === uri);
      if (series) {
        series.selected = false;
      }
    }
  }

  onRowHover(ts: any) {
    // Handle hover
    //console.log('Row hover:', ts);
    this.events.trigger('timeSeriesHover', ts.uri, event);
  }

  onRowLeave(ts: any) {
    // Handle leave
    //console.log('Row leave:', ts);
    this.events.trigger('timeSeriesUnhover', ts.uri, event);
  }

  onRowClick(ts: any) {
    // Handle click
    ts.selected = !ts.selected;
    this.events.trigger(ts.selected ? 'timeSeriesSelect' : 'timeSeriesUnselect', ts.uri, event);
    //console.log('Row clicked:', ts);
  }

  widgetLiveDataLoaded(s: any) {
    //var item = this.c.tableDetailList.find(d => d.uri == s.uri) as any;
    this.categories = []; //reset categories for date range change
    let item = <any>this.c.dynamicTimeSeriesList[s.index];
    if (item == null){
      item = this.c.dynamicTimeSeriesList.find(d => d.uri == s.uri) as any;
    }
    item.value = Math.round(s.point.value*1000)/1000;
    item.colour = null;
    item.name = s.point.value;
    const zoneColours = item.zoneColours == null || item.zoneColours.length == 0 ? this.c.zoneColours : item.zoneColours;
    if (zoneColours){
      for (let r of zoneColours){
        if (item.value >= r.min && item.value <= r.max){
          item.colour = r.colour;
        }
      }
    }
    if (item.values == null){
      item.values = this.tidyHistory(null);
    }

    const values = [...item.values];
    if (values.length > this.history){
      values.shift();  
    }
    values.push(item.value);
    item.values = this.tidyHistory(values);
  }

  widgetDataLoadTimeout(){
    
  }

  widgetDataLoaded(s: SharedSeries) {
    this.categories = []; //reset categories for date range change
    const item = <any>this.c.dynamicTimeSeriesList[s.index];
    let values = this.tidyHistory(null);
    if (this.c.showCategories == null || this.c.showCategories == false){
      if (s.values.length > 0){
        // no more that 3 decimal places allowed
        item.value = Math.round(s.values[s.values.length - 1].value*1000)/1000;
        //item.colour = "#d1dade";
        let colour = null;
        const zoneColours = item.zoneColours == null || item.zoneColours.length == 0 ? this.c.zoneColours : item.zoneColours;
        if (zoneColours){
          for (let r of zoneColours){
            if (item.value >= r.min && item.value <= r.max){
              colour = r.colour;
            }
          }
        }
        item.colour = colour;

      }
      else {
        item.value = null;
        item.percentage = 0;
      }
      for (let item of s.values){
        values.push(item.value);
      }
      values = this.tidyHistory(values);
      item.values = values;
      item.loaded = true;
    }
    else {
      // categories
      // we want to have a column per series
      // and a row per category
      const v = s.values[s.values.length - 1].value;
      const j = JSON.parse(v);
      for (var cat in j){
        if (!this.categories.find(c => c == cat)){
          this.categories.push(cat);
        }
        item.value = j;
      }
      this.categories.sort();
    }
  }

  tidyHistory(values: number[]) : number[]{
    if (values == null || values.length == 0){
      values = [];
    }
    while (values.length < this.history){
      values.unshift(0);
    }
    while (values.length > this.history){
      values.shift();
    }
    return values;
  }

  widgetDataAdded(s: SharedPoint) {
    
  }

  ngDoCheck() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

}
